import React, { useState } from 'react';
import { EventsFilterGroupComputeds } from './EventsFilterGroupComputeds';
import { FilterKindType } from './EventsFilterType';
import { observer } from 'src/utils/mobx-react';
import { FiltersState, FiltersStateStrategyType } from 'src/domains/layouts/webview/components/filters/Filters.state';
import { Filters } from 'src/domains/layouts/webview/components/filters/Filters';
import { FiltersSkinType } from 'src/domains/layouts/webview/components/filters/FiltersSkin';
import {
    Label,
    NameContainer,
    Right,
    Wrapper,
} from 'src/domains/sportsbook/webview/components/eventsFilters/EventsFilterGroup.style';
import { FiltersScrollableWrapper } from 'src/domains/layouts/webview/components/filters/FiltersScrollableWrapper';

interface EventsFiltersPropsType {
    strategy: FiltersStateStrategyType;
    skin: FiltersSkinType;
}

const EventsFilters = observer('EventsFilters', (props: EventsFiltersPropsType) => {
    const { strategy, skin } = props;
    const [state] = useState(() => new FiltersState(strategy));
    return (
        <FiltersScrollableWrapper>
            <Filters
                state={state}
                skin={skin}
            />
        </FiltersScrollableWrapper>
    );
});

interface RenderFilterItemResultType {
    name: React.ReactElement;
    body: React.ReactElement;
}

const renderFilterItem = (
    eventsFilterState: EventsFilterGroupComputeds,
    filterId: FilterKindType,
    skin: FiltersSkinType
): RenderFilterItemResultType => {
    switch (filterId) {
        case 'sport': {
            const state = eventsFilterState.sport;

            return {
                name: <Label key='sport'>{state.name}</Label>,
                body: (
                    <EventsFilters
                        strategy={state}
                        skin={skin}
                        key='sport'
                    />
                ),
            };
        }

        case 'competition': {
            const state = eventsFilterState.competition;

            return {
                name: <Label key='competition'>{state.name}</Label>,
                body: (
                    <EventsFilters
                        strategy={state}
                        skin={skin}
                        key='competition'
                    />
                ),
            };
        }

        case 'time': {
            const state = eventsFilterState.time;

            return {
                name: <Label key='time'>{state.name}</Label>,
                body: (
                    <EventsFilters
                        strategy={state}
                        skin={skin}
                        key='time'
                    />
                ),
            };
        }

        case 'region': {
            const state = eventsFilterState.region;

            return {
                name: <Label key='region'>{state.name}</Label>,
                body: (
                    <EventsFilters
                        strategy={state}
                        skin={skin}
                        key='region'
                    />
                ),
            };
        }

        case 'country': {
            const state = eventsFilterState.country;

            return {
                name: <Label key='country'>{state.name}</Label>,
                body: (
                    <EventsFilters
                        strategy={state}
                        skin={skin}
                        key='country'
                    />
                ),
            };
        }
    }
};

const renderFilters = (
    eventsFilter: EventsFilterGroupComputeds,
    filters: Array<FilterKindType>,
    skin: FiltersSkinType
): Array<RenderFilterItemResultType> => {
    const out = [];

    for (const filterKind of filters) {
        out.push(renderFilterItem(eventsFilter, filterKind, skin));
    }

    return out;
};

interface PropsType {
    filters: Array<FilterKindType>;
    eventsFilter: EventsFilterGroupComputeds;
    skin: FiltersSkinType;
}

export const EventsFilterGroup = observer('EventsFilterGroup', (props: PropsType): JSX.Element | null => {
    const { filters, eventsFilter, skin } = props;
    const filtersJsx = renderFilters(eventsFilter, filters, skin);

    if (filtersJsx.length > 1) {
        return (
            <Wrapper>
                <NameContainer>{filtersJsx.map((item) => item.name)}</NameContainer>

                <Right>{filtersJsx.map((item) => item.body)}</Right>
            </Wrapper>
        );
    } else if (filtersJsx.length === 1) {
        return filtersJsx[0]?.body ?? null;
    }

    return null;
});
